
export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: null
    },
    titleTag: {
      type: String,
      default: 'h2'
    },
    description: {
      type: String,
      default: null
    }
  },
  vessel: {
    title: {
      fontSize: 'xl',
      lg: {
        fontSize: '3xl'
      }
    }
  }
}
